import React, { useEffect, useState } from "react";
import { Mascot } from "@/components/Mascot";

const BrandMark = ({ src }) => (
  <img src={src} alt="GjejShqip" style={{ height: 48, width: "auto" }} draggable={false} />
);

const keep = (url, set) => fetch(url).then((r) => r.blob()).then((b) => set(URL.createObjectURL(b))).catch(() => {});

export function OfflineOverlay() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [logo, setLogo] = useState("/logo-full.png");
  const [mascot, setMascot] = useState("/mascot-sad.webp");
  useEffect(() => { keep("/logo-full.png", setLogo); keep("/mascot-sad.webp", setMascot); }, []);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);

  if (online) return null;

  return (
    <div className="fixed inset-0 z-[200] bg-white flex flex-col items-center justify-center px-8 text-center" data-testid="offline-overlay">
      <BrandMark src={logo} />
      <Mascot src={mascot} testid="offline-mascot" size={170} title="Nuk ke qasje në rrjet" text="Kontrollo lidhjen me internetin ose provo përsëri. Mund të ketë edhe një problem teknik të përkohshëm." />
      <button data-testid="offline-retry" onClick={() => window.location.reload()} className="mt-2 h-11 px-6 rounded-xl bg-emerald-500 text-white font-semibold text-sm">Provo përsëri</button>
    </div>
  );
}

export default OfflineOverlay;
